<div class="modal-header">
  <h2>{{ 'RECIPE.NEW_RECIPE' | translate }}</h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-3" [formGroup]="recipeForm">
  <label class="custom-label"
    >{{ 'RECIPE.NAME' | translate }}
    <input
      type="text"
      class="custom-input"
      formControlName="name"
      [placeholder]="'RECIPE.NAME' | translate" />
    <app-control-errors id="name" controlName="name"></app-control-errors
  ></label>
   <label class="custom-label w-100">
    <input type="checkbox" formControlName="multilevel" />
    {{ 'RECIPE.MULTILEVEL' | translate }}
  </label>
</div>
<div class="modal-footer">
  <button
    [disabled]="!recipeForm.valid"
    (click)="createNewRecipe()"
    class="button-primary"
  >
    {{ 'GLOBAL.CREATE' | translate }}
  </button>
</div>
